
import Vue from 'vue';
import ShapeEven from '@/assets/svg/icons/shape-even.svg';
import { transformLink, TransformLinkReturn } from '~/transforms/transformComponents';
import { trackTeaserClick } from '~/utility/tracking';

export default Vue.extend({
  components: {
    ShapeEven,
  },
  props: {
    headline: {
      type: String,
      required: false,
    },
    copy: {
      type: String,
    },
    link: {
      type: Object,
      required: false,
    },
    linkLabel: {
      type: String,
      required: false,
    },
    decorElement: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
    },
  },
  computed: {
    linkData(): TransformLinkReturn {
      return transformLink(this.link, this.linkLabel);
    },
  },
  methods: {
    handleTeaserClick(event: MouseEvent): void {
      if (process.client && this.linkData) {
        trackTeaserClick(this.headline, this.linkData.url);
      }
    },
  },
});
